module.exports = __webpack_public_path__ + "img/02_1_2_5.824f19be.png";